if (typeof(countryPersonalisation) !== 'undefined' && countryPersonalisation === true) {

    var entryRequirementText = '<p>Please see our <a href="https://www.abdn.ac.uk/study/international/requirements/">entry requirements page</a> or <a href="mailto:study@abdn.ac.uk">contact the International Office</a>.</p>';

    // Set selectize options.
    var options = {
        // Load plug-in to display message when there are no results.
        plugins: {
            'no_results': {
                // This is defined in countries.source.php
                // (as it pulls in information from PHP such as the enquiry link).
                'emptyMessage': countrySelect.emptyMessage
            }
        },

        // Search in multiple fields.
        searchField: ['text', 'value', 'alternativeSpellings', 'nationality', 'nativeName'],

        // Preserve data-* attributes.
        onInitialize: function() {
            var s = this;
            this.revertSettings.$children.each(function () {
                $.extend(s.options[this.value], $(this).data());
            });

            //
            if (getQueryStringParameter('country')) {
                if (validateCountry(getQueryStringParameter('country'))) {
                    if (country) {
                        s.setValue(getQueryStringParameter('country'));
                    } else {
                        if (validateCountry(Cookies.get('abdn_country'))) {
                            s.setValue(Cookies.get('abdn_country'));
                        }
                    }
                } else {
                    if (validateCountry(Cookies.get('abdn_country'))) {
                        s.setValue(Cookies.get('abdn_country'));
                    }
                }
            } else if (Cookies.get('abdn_country')) {
                if (validateCountry(Cookies.get('abdn_country'))) {
                    s.setValue(Cookies.get('abdn_country'));
                }
            }
        },
        onFocus: function() {
            this.clear();
        },
        onType: function() {
            if (!this.hasOptions) {
                $('.country-select form').submit(function(e){
                    e.preventDefault();
                });
            }
        },
        onItemAdd: function(value, $item) {
            // Validate country code.
            if (!validateCountry(value)) return false;

            // Update section.
            $.get(countryAPIPath + '/' + value + '?item_id=' + programmeId, function(data) {
            }).done(function(data) {

                var content  = '';
                var isTabbed = false;
                // Check if UG
                if (typeof data[1].UgEntryRequirements !== 'undefined'){
                    var ugEntryReq  = data[1]['UgEntryRequirements'];
                    if (ugEntryReq.length > 0) {
                        var html = '';
                        html += '<dl class="tabcordion selected_country">';
                        for (var i = 0; i < ugEntryReq.length; i++) {
                            html += '<dt><a href="#academic_y_'+i+'">'+ugEntryReq[i]['academic_year']['title']+'</a></dt>';
                            html += '<dd id="#academic_y_'+i+'">'+ugEntryReq[i]['text']+'</dd>';
                        }

                        html += '</dl>';
                        content = html;
                        isTabbed = true;
                    } else {
                        content = entryRequirementText;
                    }
                }

                // Check if PGT
                if (typeof data[1].pgt_country_entry_req !== 'undefined'){
                    if (typeof data[1].pgt_country_entry_req[1] === 'undefined') {
                        if (data[1].iso3166_country_code === 'GB') {
                            content = '<p>' + countryContentGBText + '</p>';
                        } else {
                            content = entryRequirementText;
                        }
                    } else {
                        for (var i = 0; i < data[1].pgt_country_entry_req.length; i++) {
                            if (data[1].pgt_country_entry_req[i]['uk_qualifications']['items'].length > 0) {
                                content += '<p>' + data[1].pgt_country_entry_req[i].text + '</p>';
                            }
                        }
                    }
                }

                // Save country selection (in cookie).
                saveCountry(value, false);

                // TODO: Update other Selectize country controls when current one is updated.
                // updateOtherCountrySelects(value);

                // Update data.
                updateCountryPersonalisationData(content);
                if (isTabbed) {
                    $('.tabcordion.selected_country').tabcordion();
                }

            }).fail(function(data) {
                updateCountryPersonalisationData('We are having problems retrieving the information for your country or territory. Please <a href="javascript:document.location.reload()">refresh the page</a>.');
            });
        },
        render: {
            item: function(item, escape) {
                return '<div class="item">' +
                        '<span class="country-select-name">' + item.text + '</span>' +
                    '</div>';
            },
            option: function(item, escape) {
                return '<div class="option">' +
                        '<span class="country-select-name">' + item.text + '</span>' +
                    '</div>';
            }
        }
    };

    require ('./selectize_plugin_no_results.js');

    if (cutsTheMustard()) {
        // check that the dropdown exists
        if ($('.country-select-selectize').length) {
            // Initialize the Selectize control.
            var $select = $('.country-select-selectize').selectize(options);

            // Fetch the first Selectize instance.
            var Selectize = $select[0].selectize;

            $('.country-select-button').hide();

            // Set currently selected country value (and clear empty results message
            // when clicking outside of control.
            $(window).on('click', function() {
                if (!Selectize.getValue()) {
                    Selectize.setValue(Cookies.get('abdn_country'));
                }

                Selectize.$empty_results_container.hide();
            });

            $('.country-select .selectize-control').on('click', function(event){
                event.stopPropagation();
            });

            $('.country-select-label').on('click', function(){
                Selectize.open();
            });
        }
    }

    // Update query string parameter with selected value.
    function updateQueryStringParam(key, value){

        var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
            urlQueryString = document.location.search,
            newParam = key + '=' + value,
            params = '?' + newParam;

        // If the "search" string exists, then build params from it
        if (urlQueryString) {
            var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
            var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

            if(typeof value == 'undefined' || value == null || value == '') { // Remove param if value is empty
                params = urlQueryString.replace(removeRegex, "$1");
                params = params.replace( /[&;]$/, "" );

            } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                params = urlQueryString.replace(updateRegex, "$1" + newParam);

            } else { // Otherwise, add it to end of query string
                params = urlQueryString + '&' + newParam;
            }
        }

        // no parameter was set so we don't need the question mark
        params = params == '?' ? '' : params;

        if (window.history && window.history.pushState) {
            window.history.replaceState({}, "", baseUrl + params);
        }
    };

    // Get URL parameter.
    function getQueryStringParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function validateCountry(country) {
        var regex = /^[A-Z]{2}$/;

        // Validate country according to regex.
        if (typeof country !== 'undefined' && country.match(regex)) {
            return true;
        };

        return false;
    }

    function saveCountry(country, updateQueryString) {
        if (!validateCountry(country)) return false;

        if (updateQueryString) {
            // Update query string with country.
            updateQueryStringParam('country', country);
        }

        // Update cookie.
        Cookies.set('abdn_country', country, { expires: 30 });

        return true;
    }

    // Update country selection on all Selectize controls except the current one.
    // function updateOtherCountrySelects(value) {
        // TODO: Update other country selects.
        // console.log(value);
    // }

    // Update country personalisation data for current selectize control.
    function updateCountryPersonalisationData(content) {
        // TODO: update nearest Selectize control.
        $("#country_entry_requirements .country-personalisation-content").html(content);
    }

}
